import { render, staticRenderFns } from "./leadDetail.vue?vue&type=template&id=3644c958&scoped=true&"
import script from "./leadDetail.vue?vue&type=script&lang=js&"
export * from "./leadDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3644c958",
  null
  
)

export default component.exports